import React, { useContext, useEffect, useState } from 'react';
import { connect } from 'react-redux'
import { List, Radio, Item, Label, Card, Icon} from 'semantic-ui-react'
import { Text, Translate, LanguageContext } from '../../helpers/language';
 

/** 
 * Needs the following passed as props:
 * plan: the plan
 * selected: the item is selected
 * handlePlanChange: change handler
**/
const RegistrationSubscriptionItem = (props) => {
    
    const languageContext = useContext(LanguageContext);

    const translations_prefix = props.translations_prefix ? props.translations_prefix : '';
    const plan = props.plan;
    const trial_days = props.trial_days ? props.trial_days : '';
    const selected = props.selected ? props.selected : false;

    const handleClick = () => {
        if (props.handlePlanChange) {
            props.handlePlanChange(plan.id);
        }
    }

       
    return (
        <Card className={selected ? "lisia-selected-price-tile" : "lisia-price-tile" }
                raised 
                onClick={handleClick} 
        >
        <Card.Content>            
            <Card.Header className='lisia-registration-price-header'>                
                {Translate(languageContext, translations_prefix + plan.nickname).replace(/\${days}/, trial_days)}
            </Card.Header>
            <Card.Meta>      
                <div className='lisia-registration-price-text'>      
                    { plan.metadata.strikeout_amount && <div style={{color: 'red'}}><del>{(plan.metadata.strikeout_amount/100.0).toFixed(2)}<Text tid={plan.currency} /></del></div>}
                    <b>
                        {
                        plan.amount > 0.0 ? 
                            plan.coupon ?
                            <>
                            {!plan.metadata.strikeout_amount && 
                                <div style={{color: 'red'}}>
                                    <del>{(plan.amount/100.0).toFixed(2)}<Text tid={plan.currency} />
                                    </del>
                                </div> 
                            }
                            {plan.coupon.metadata.previous_percentage_discount && 
                                <div style={{color: 'darkred'}}>
                                    <del>{((plan.amount - (plan.coupon.metadata.previous_percentage_discount * plan.amount/100.0))/100.0).toFixed(2)}<Text tid={plan.currency} />
                                    </del>
                                </div> 
                            }
                            {plan.coupon.metadata.previous_amount_off && 
                                <div style={{color: 'darkred'}}>
                                    <del>{((plan.amount - plan.coupon.metadata.previous_amount_off)/100.0).toFixed(2) }<Text tid={plan.currency} />
                                    </del>
                                </div> 
                            }
                            <span style={{color: 'green'}}>
                                { plan.coupon.amount_off && 
                                            ((plan.amount - plan.coupon.amount_off)/100.0).toFixed(2) 
                                }
                                { plan.coupon.percent_off && 
                                            ((plan.amount - (plan.coupon.percent_off * plan.amount/100.0))/100.0).toFixed(2) 
                                }<Text tid={plan.currency} />
                                {
                                    plan.coupon.duration === 'repeating'  && plan.recurring && <> / <Text tid={plan.recurring.interval} /> <Text tid='subscription_coupon_period_prefix' /> {plan.coupon.duration_in_months} <Text tid='months' />, <Text tid='then' />: </>
                                }
                                {
                                    plan.coupon.duration === 'forever' && plan.recurring && <> / <Text tid={plan.recurring.interval} /></>
                                }
                                {
                                    plan.coupon.duration === 'once' && plan.recurring && <> / <Text tid={plan.recurring.interval} /> <Text tid='once' />, <Text tid='then' />: </>
                                }                              
                            </span>
                            </> 
                            :
                            <>
                                { (plan.amount/100.0).toFixed(2) }<Text tid={plan.currency} /> {plan.recurring ? <> / <Text tid={plan.recurring.interval} /> </> : '' }
                            </>
                        :
                        plan.coupon ? 
                        <> 
                            { (plan.amount/100.0).toFixed(2) }<Text tid={plan.currency} /> 
                            { plan.coupon.metadata.description && <div style={{color: 'green'}}>
                                {plan.coupon.metadata.description}
                                </div>  
                            }
                        </>
                        :
                        <> 
                            { (plan.amount/100.0).toFixed(2) }<Text tid={plan.currency} /> 
                        </>
                        }                            
                    </b>                   
                </div>
            </Card.Meta>                   
        </Card.Content>
        </Card>  
    )
 
}

const mapStateToProps = (state) => ({
    auth: state.auth
  })

export default connect(mapStateToProps)(RegistrationSubscriptionItem)
